// extracted by mini-css-extract-plugin
export default {"homeworkCell":"App_homeworkCell__Ak+sr","timetableCell":"App_timetableCell__F4UAh","tblGrid":"App_tblGrid__xm1y5","header":"App_header__fhC8n"};